'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

var _resources = require('redux/modules/resources');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// do you keep fruit in a bowl that he/she can easily see?
var YES = 'Yes';
var NO = 'No';
var IDK = 'Don\'t know';
var SOMETIMES = 'Sometimes';

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2App5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app5
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem, changeResource: _resources.changeResource })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App5, _Component);

  function Module2App5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App5.__proto__ || (0, _getPrototypeOf2.default)(Module2App5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 5,
      title: 'Accessibility of fruit and veges',
      isCompleted: _this.props.app.isCompleted || false,
      childEasilySeeFruit: _this.props.app.childEasilySeeFruit || '', // do you keep fruit in a bowl that he/she can easily see?
      takeFruitWithoutAsk: _this.props.app.takeFruitWithoutAsk || '', // is he/she allowed to take fruit without asking?
      easySeeVege: _this.props.app.easySeeVege || '', // can he/she easily see vegetables displayed in the home eg. fridge?
      keepFruitVegeFridge: _this.props.app.keepFruitVegeFridge || '', // do you ever keep a supply of chopped up fruit and vegies in the fridge?
      whatCutUp: _this.props.app.whatCutUp || '' // what vegetables and fruits do you cut up?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handlechildEasilySeeFruit = function (event) {
      var obj = _this.state;
      obj.childEasilySeeFruit = event.target.value;
      obj.takeFruitWithoutAsk = '';
      obj.easySeeVege = '';
      obj.keepFruitVegeFridge = '';
      _this.setState(obj);
    }, _this.handletakeFruitWithoutAsk = function (event) {
      var obj = _this.state;
      obj.takeFruitWithoutAsk = event.target.value;
      obj.easySeeVege = '';
      obj.keepFruitVegeFridge = '';
      _this.setState(obj);
    }, _this.handleeasySeeVege = function (event) {
      var obj = _this.state;
      obj.easySeeVege = event.target.value;
      obj.keepFruitVegeFridge = '';
      _this.setState(obj);
    }, _this.handlekeepFruitVegeFridge = function (event) {
      var obj = _this.state;
      obj.keepFruitVegeFridge = event.target.value;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      // console.log(event);
      _this.props.changeItem(module, modtype, item);
    }, _this.handleResourceClick = function (module, item, event) {
      // console.log(event);
      _this.props.changeResource(module, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  /* *************** */
  /* HANDLE ON CLICK */
  /* *************** */

  // used to navigate to a resource item


  // used to navigate to a resource item


  (0, _createClass3.default)(Module2App5, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Now we\'ll talk about the types of foods that are in your home and how accessible they are to your child.'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Do you keep fruit in a bowl that he/she can easily see?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handlechildEasilySeeFruit },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'childEasilySeeFruit', value: YES, checked: this.state.childEasilySeeFruit === YES },
              YES
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'childEasilySeeFruit', value: NO, checked: this.state.childEasilySeeFruit === NO },
              NO,
              '/only sometimes'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'childEasilySeeFruit', value: IDK, checked: this.state.childEasilySeeFruit === IDK },
              IDK
            )
          ),
          this.state.childEasilySeeFruit === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Excellent!'
            )
          ),
          (this.state.childEasilySeeFruit === NO || this.state.childEasilySeeFruit === IDK) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'If kids can see fruit, then they\'re more likely to eat it.'
            )
          ),
          this.state.childEasilySeeFruit && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Is he/she allowed to take fruit without asking?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handletakeFruitWithoutAsk },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'takeFruitWithoutAsk', value: YES, checked: this.state.takeFruitWithoutAsk === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'takeFruitWithoutAsk', value: NO, checked: this.state.takeFruitWithoutAsk === NO },
                NO,
                '/only sometimes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'takeFruitWithoutAsk', value: SOMETIMES, checked: this.state.takeFruitWithoutAsk === SOMETIMES },
                SOMETIMES
              )
            )
          ),
          this.state.takeFruitWithoutAsk && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Can he/she easily see vegetables displayed in the home eg. fridge?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleeasySeeVege },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'easySeeVege', value: YES, checked: this.state.easySeeVege === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'easySeeVege', value: NO, checked: this.state.easySeeVege === NO },
                NO
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'easySeeVege', value: IDK, checked: this.state.easySeeVege === IDK },
                IDK
              )
            )
          ),
          this.state.easySeeVege && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Do you ever keep a supply of chopped-up fruit and vegies in the fridge?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handlekeepFruitVegeFridge },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'keepFruitVegeFridge', value: YES, checked: this.state.keepFruitVegeFridge === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'keepFruitVegeFridge', value: NO, checked: this.state.keepFruitVegeFridge === NO },
                NO
              ),
              this.state.keepFruitVegeFridge === NO && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Children are more likely to eat vegies and fruit if they are ready to eat, like carrot or celery chopped up into sticks or grapes cut into small bunches'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'keepFruitVegeFridge', value: SOMETIMES, checked: this.state.keepFruitVegeFridge === SOMETIMES },
                SOMETIMES
              ),
              this.state.keepFruitVegeFridge === SOMETIMES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'If you can keep pre-chopped fruits and vegies in the fridge there\'ll always be a healthy snack available.'
                    )
                  )
                )
              )
            ),
            this.state.keepFruitVegeFridge === YES && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Great. Children are more likely to eat vegies (and fruit) if they are READY to eat'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'What vegetables (and fruits) do you cut up for your child?'
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'What vegetables do I cut up?', value: this.state.whatCutUp,
                  onChange: this.handleChange.bind(this, 'whatCutUp') })
              ),
              _react2.default.createElement('div', { className: styles.spacer20 })
            )
          ),
          (this.state.keepFruitVegeFridge === NO || this.state.keepFruitVegeFridge === SOMETIMES) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'A helpful way of doing this is to wash and chop up some of your vegies as you put them away after shopping. Snap-lock bags are a very handy way to store chopped up vegetables.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For tips on how to correct store fruit and vegetables see the guide under ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/resourceslanding', onClick: this.handleResourceClick.bind(this, 2, 10) },
                'Module 2 Resources'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
            _react2.default.createElement('div', { className: styles.spacer20 })
          )
        )
      );
    }
  }]);
  return Module2App5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  changeResource: _propTypes2.default.func.isRequired
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Module2App5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App5.js
// module id = 1185
// module chunks = 0